import { render, staticRenderFns } from "./TikTokAuthorize.vue?vue&type=template&id=792888d2&scoped=true"
import script from "./TikTokAuthorize.vue?vue&type=script&lang=js"
export * from "./TikTokAuthorize.vue?vue&type=script&lang=js"
import style0 from "./TikTokAuthorize.vue?vue&type=style&index=0&id=792888d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792888d2",
  null
  
)

export default component.exports